/* Approved German UI text only. Consent state, app handlers and review counts stay app-owned. */
(() => {
  'use strict';
  if (!document.documentElement.lang.toLowerCase().startsWith('de')) return;
  const translations = [
  [
    "Essential",
    "Erforderliche Cookies"
  ],
  [
    "Required Category",
    "Immer aktiv"
  ],
  [
    "Enables advertising cookies from platforms like Google Ads and Facebook Pixel. These cookies track your visit across websites to show you relevant ads and measure ad performance.",
    "Ermöglicht Werbe-Cookies von Plattformen wie Google Ads und Facebook Pixel. Diese Cookies erfassen deine Besuche auf verschiedenen Websites, um dir passende Werbung zu zeigen und deren Leistung zu messen."
  ],
  [
    "Required for the website to work properly. Includes session tokens, shopping cart data, and security cookies. These cannot be disabled as the site depends on them.",
    "Diese Cookies sind für die grundlegenden Funktionen der Website erforderlich. Dazu gehören Sitzungstoken, Warenkorbdaten und Sicherheits-Cookies. Sie können nicht deaktiviert werden, da die Website sie benötigt."
  ],
  [
    "Helps us understand how visitors use the site. Collects page views, session duration, click patterns, and traffic sources via tools like Google Analytics and Microsoft Clarity.",
    "Hilft uns zu verstehen, wie Besucher die Website nutzen. Erfasst Seitenaufrufe, Sitzungsdauer, Klickmuster und Zugriffsquellen mit Tools wie Google Analytics und Microsoft Clarity."
  ],
  [
    "We respect your privacy",
    "Wir respektieren deine Privatsphäre"
  ],
  [
    "Learn more",
    "Mehr erfahren"
  ],
  [
    "Manage",
    "Einstellungen verwalten"
  ],
  [
    "Settings",
    "Cookie-Einstellungen"
  ],
  [
    "Cookie Usage",
    "Verwendung von Cookies"
  ],
  [
    "We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose to accept cookies or opt-out whenever you want. For more details, read the full privacy policy.",
    "Wir verwenden Cookies, um die grundlegenden Funktionen der Website bereitzustellen und dein Online-Erlebnis zu verbessern. Du kannst Cookies akzeptieren oder jederzeit ablehnen. Weitere Informationen findest du in der vollständigen Datenschutzerklärung."
  ],
  [
    "Essential Required Category",
    "Erforderliche Cookies"
  ],
  [
    "Analytics",
    "Analyse"
  ],
  [
    "More Information",
    "Weitere Informationen"
  ],
  [
    "For any queries in relation to our policy on cookies and your choices, please contact us.",
    "Bei Fragen zu unserer Cookie-Richtlinie oder deinen Auswahlmöglichkeiten kontaktiere uns bitte."
  ],
  [
    "Consent ID:",
    "Einwilligungs-ID:"
  ],
  [
    "Save Preference",
    "Auswahl speichern"
  ],
  [
    "Accept All",
    "Alle akzeptieren"
  ],
  [
    "Reject All",
    "Alle ablehnen"
  ]
];
  const scopes = '#raksha-consent-banner, #raksha-modal, .loox-rating, .bndlr-bundle-description, .slick-prev, .slick-next';
  function translate(value, cookie) {
    let result = value;
    if (cookie) for (const [from,to] of translations) {
      if (from.length > 90 || from === 'Consent ID:' || result.trim() === from) result = result.split(from).join(to);
    }
    else result = result.replace(/(\d[\d.,]*)(\s+)reviews\b/g, '$1$2Bewertungen').replace('Kombinieren und speichern!', 'Kombinieren und sparen!');
    if (!cookie && result.trim() === 'Previous') result = result.replace('Previous', 'Zurück');
    if (!cookie && result.trim() === 'Next') result = result.replace('Next', 'Weiter');
    return result;
  }
  function localize(root) {
    const cookie = root.id === 'raksha-consent-banner' || root.id === 'raksha-modal';
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement.closest('script, style, textarea')) continue;
      const value = translate(node.nodeValue, cookie);
      if (value !== node.nodeValue) node.nodeValue = value;
    }
    for (const element of [root, ...root.querySelectorAll('[aria-label], [title]')]) {
      for (const attr of ['aria-label','title']) {
        const before = element.getAttribute(attr);
        if (before !== null) { const after = translate(before,cookie); if (after !== before) element.setAttribute(attr,after); }
      }
    }
  }
  function styleConsent() {
    const banner = document.getElementById('raksha-consent-banner');
    if (!banner) return;
    const styles = {width:'480px','max-width':'100vw',bottom:'0',left:'0',right:'auto',padding:'18px',border:'0','border-radius':'0','box-shadow':'0 0 8px rgba(0,0,0,.15)',color:'#000','font-family':'Inter, sans-serif'};
    for (const [key,value] of Object.entries(styles)) if (banner.style.getPropertyValue(key) !== value) banner.style.setProperty(key,value,'important');
  }
  const discountSections = new WeakSet();
  function updateDiscounts() {
    document.querySelectorAll('.product.section').forEach(section => {
      if (discountSections.has(section)) return;
      const select = section.querySelector('[data-product-master-select]');
      if (!select) return;
      const sync = variant => section.querySelectorAll('.dbtfy-discount-saved__item').forEach(badge => {
        badge.hidden = badge.dataset.variantId !== String(variant?.id || select.value);
      });
      sync();
      section.addEventListener('variantChange', event => sync(event.detail?.variant));
      discountSections.add(section);
    });
  }
  function scan() { document.querySelectorAll(scopes).forEach(localize); styleConsent(); updateDiscounts(); }
  let queued = false;
  const observer = new MutationObserver(records => {
    if (queued || !records.some(r => r.type === 'childList' || r.target.parentElement?.closest(scopes))) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  });
  scan();
  observer.observe(document.body, {childList:true,subtree:true,characterData:true});
})();
